// extracted by mini-css-extract-plugin
export default {"vacancyCreateWrapper":"mapOutlets_vacancyCreateWrapper__RbNY9"};